// extracted by mini-css-extract-plugin
export default {"container":"Staff_container__puMr4","staffContainer":"Staff_staffContainer__uB0n4","staffImageContainer":"Staff_staffImageContainer__3QW8Y"};